module.exports = __webpack_public_path__ + "static/media/lyft-image.cac489f5.jpg";